<template>
  <div class="manage-question">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <template #title>
        <a-row type="flex" align="middle">
          <h6 class="font-semibold m-0">Danh sách user request consultation</h6>
        </a-row>
      </template>
      <a-table
        :columns="columns"
        :loading="callingAPI"
        :data-source="dataSource"
        :pagination="pagination"
        @change="handleChange"
        rowKey="id"
      >
        <template slot="status" slot-scope="row">
          <a-tag :color="row.status === 1 ? 'green' : 'red'">
            {{ row.status === 1 ? "Đã tư vấn" : "Chưa tư vấn" }}
          </a-tag>
        </template>
        <template slot="type" slot-scope="row">
          <b>{{ row.type }}</b>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { fetchUserRegister } from '@/services/landing-page/registerConsultation'
  export default {
    name: 'ManageRegisterService',
    data() {
      return {
        callingAPI: true,
        pageSize: 1000,
        total: 0,
        dataSource: [],
        columns: [
          {
            title: 'Email',
            dataIndex: 'email',
            scopedSlots: { customRender: 'title' },
            class: 'font-semibold',
          },
          {
            title: 'Phone',
            dataIndex: 'phone',
            class: 'font-semibold'
          },
          {
            title: 'Loại',
            scopedSlots: { customRender: 'type' },
          },
          {
            title: 'Nội dung',
            dataIndex: 'content',
            scopedSlots: { customRender: 'content' },
          },
          {
            title: 'Trạng thái',
            scopedSlots: { customRender: 'status' },
          },
        ],
        pagination: {
          total: 0,
          pageSize: 10,
          current: 1
        },
      }
    },
    async beforeMount() {
      await this.loadData()
    },
    methods: {
      async loadData(page) {
        try {
          this.callingAPI = true
          const params = {
            per_page: this.pagination.pageSize,
            page: this.pagination.current
          }
          const response = await fetchUserRegister(params)
          this.dataSource = response.data.data.map((d) =>({
            ...d,
            status: d.status === 1,
            loadingActive: false
          }))
          this.pagination.total = response.data.total
          this.callingAPI = false
        } catch (error) {}
      },

      async handleChange(pagination) {
        this.pagination.current = pagination.current;
        this.loadData()
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>